/** @module components/visitors */


import {ChoiceQuiz, ChoiceQuizVisitor} from '../choice-quiz';
import {ClozeQuiz, ClozeQuizVisitor, SelectSpan} from '../cloze-quiz';
import {DragAndDropQuiz, DragAndDropQuizVisitor} from '../drag-and-drop-quiz';
import {HotSpotQuiz, HotSpotQuizVisitor} from '../hot-spot-quiz';
import {QuizVisitor, canShowCorrectness} from '../quiz';


/**
 * Visitor that will reset [[CanShowCorrectness.showCorrectness]] of all answers to `false`.
 *
 * Use this visitor to "hide" correctness feedback.
 *
 * @example
 *```typescript
 *
 * new ShowCorrectnessOfNoAnswersQuizVisitor().visit(quiz);
 *```
 */
export class ShowCorrectnessOfNoAnswersQuizVisitor extends QuizVisitor implements ChoiceQuizVisitor, ClozeQuizVisitor, DragAndDropQuizVisitor, HotSpotQuizVisitor {

    public visitChoiceQuiz(quiz: ChoiceQuiz): void {
        for (const choice of quiz.choices) {
            if (canShowCorrectness(choice)) {
                choice.showCorrectness = false;
            }
        }
    }

    public visitClozeQuiz(quiz: ClozeQuiz): void {
        for (const paragraph of quiz.paragraphs) {
            for (const span of paragraph.spans) {
                if (canShowCorrectness(span)) {
                    span.showCorrectness = false;
                }
                if (span instanceof SelectSpan) {
                    for (const choice of span.choices) {
                        if (canShowCorrectness(choice)) {
                            choice.showCorrectness = false;
                        }
                    }
                }
            }
        }
    }

    public visitDragAndDropQuiz(quiz: DragAndDropQuiz): void {
        for (const dropArea of quiz.dropAreas) {
            for (const item of dropArea.items) {
                if (canShowCorrectness(item)) {
                    item.showCorrectness = false;
                }
            }

            // TODO: this is a hack to trigger a DOM update:
            dropArea.change.dispatch({ name: 'items', newValue: dropArea.items, oldValue: dropArea.items });
        }
    }

    public visitHotSpotQuiz(quiz: HotSpotQuiz): void {
        for (const spot of quiz.spots) {
            if (canShowCorrectness(spot)) {
                spot.showCorrectness = false;
            }
        }
        for (const hotSpotArea of quiz.hotSpotAreas) {
            if (canShowCorrectness(hotSpotArea)) {
                hotSpotArea.showCorrectness = false;
            }
        }
    }
}
